module.exports = __webpack_public_path__ + "img/logo-en.d0dbba25.png";